import '@/App.css';
import useSmoothScroll from '@/hooks/useSmoothScroll';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Ribbon } from '@/components/Ribbon';
import { About } from '@/components/About';
import { Thesis } from '@/components/Thesis';
import { Portfolio } from '@/components/Portfolio';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';

export default function Home() {
  useSmoothScroll();

  return (
    <div className="App grain">
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <About />
        <Thesis />
        <Portfolio />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
